const gameMarqueeListReducers = (state = [], action) => {
  switch (action.type) {
    case "storeGameMarqueeList":
      return action.payload;
    case "clearMarqueeList":
      return [];
    default:
      return state;
  }
};
export default gameMarqueeListReducers;
